import axios from "axios";

const BASE_URL = {
  // development: "https://aditya-unmoral-isometrically.ngrok-free.dev/",
  development: "http://localhost:8000",
  staging: "https://stg-stitch-api.hellocompanio.com",
  production: "https://stitch-api.omli.in",
};

const BASE_GOOGLE_CLIENT_ID = {
  development:
    "129318920353-i22pnbi6gsnpva6lg5jujqpoba03srmc.apps.googleusercontent.com",
  staging:
    "129318920353-i22pnbi6gsnpva6lg5jujqpoba03srmc.apps.googleusercontent.com",
  production:
    "129318920353-i22pnbi6gsnpva6lg5jujqpoba03srmc.apps.googleusercontent.com",
};

const ENV = process.env.REACT_APP_ENV || process.env.NODE_ENV || "production";

const API_BASE_URL = BASE_URL[ENV];
const GOOGLE_CLIENT_ID = BASE_GOOGLE_CLIENT_ID[ENV];

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("companioToken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("companioToken");
      window.location.reload();
    }
    return Promise.reject(error);
  },
);

export const googleLogin = async (tokenData) => {
  const response = await api.post("/auth/google", tokenData);
  return response.data;
};

export const getUsers = async () => {
  const response = await api.get("/admin/users");
  return response.data;
};

export const addAnnotator = async (email) => {
  const response = await api.post("/admin/users/add", null, {
    params: { email },
  });
  return response.data;
};

export const removeAnnotator = async (email) => {
  const response = await api.delete("/admin/users/remove", {
    params: { email },
  });
  return response.data;
};

export const reactivateAnnotator = async (email) => {
  const response = await api.post("/admin/users/reactivate", null, {
    params: { email },
  });
  return response.data;
};

export const assignAudio = async (ageGroup) => {
  const params = ageGroup ? { age_group: ageGroup } : {};
  const response = await api.post("/tasks/assign-audio", null, { params });
  return response.data;
};

export const assignVadAudio = async (filterType = "single_speaker_child") => {
  const response = await api.post("/tasks/assign-vad-audio", null, {
    params: { filter_type: filterType },
  });
  return response.data;
};

export const assignValidationAudio = async (validationRunId) => {
  const response = await api.post("/tasks/assign-validation-audio", null, {
    params: { validation_run_id: validationRunId },
  });
  return response.data;
};

export const saveAnnotation = async (taskId, annotationData) => {
  const response = await api.post(
    `/tasks/${taskId}/annotation`,
    annotationData,
  );
  return response.data;
};

export const skipTask = async (taskId) => {
  const response = await api.post(`/tasks/${taskId}/skip`);
  return response.data;
};



export const getTasks = async () => {
  const response = await api.get("/tasks");
  return response.data;
};

export const getSarvamTranscript = async (taskId) => {
  const response = await api.get(`/tasks/${taskId}/sarvam-transcript`);
  return response.data;
};

export const getHistory = async (page = 1) => {
  const response = await api.get("/history", { params: { page } });
  return response.data;
};

export const exportFinetuneCsv = async ({ startDate, endDate } = {}) => {
  const params = {};
  if (startDate) params.start_date = startDate;
  if (endDate) params.end_date = endDate;
  const response = await api.post("/api/audio/export-finetune-csv", null, { params });
  return response.data;
};

export const exportFinetuneCsvNoMidSilence = async ({ startDate, endDate } = {}) => {
  const params = { exclude_mid_silence: true };
  if (startDate) params.start_date = startDate;
  if (endDate) params.end_date = endDate;
  const response = await api.post("/api/audio/export-finetune-csv", null, { params });
  return response.data;
};

export const exportAnnotationsCsv = async ({ startDate, endDate } = {}) => {
  const params = {};
  if (startDate) params.start_date = startDate;
  if (endDate) params.end_date = endDate;
  const response = await api.post("/api/audio/export-annotations-csv", null, { params });
  return response.data;
};

export const exportAnnotationsCsvWithEos = async ({ startDate, endDate } = {}) => {
  const params = {};
  if (startDate) params.start_date = startDate;
  if (endDate) params.end_date = endDate;
  const response = await api.post("/api/audio/export-annotations-csv-with-eos", null, { params });
  return response.data;
};

export const exportFilteredAnnotationsCsv = async ({ audioType, interactionType, qualityRating, fluency, startDate, endDate } = {}) => {
  const params = {};
  if (audioType) params.audio_type = audioType;
  if (interactionType) params.interaction_type = interactionType;
  if (qualityRating != null) params.quality_rating = qualityRating;
  if (fluency) params.fluency = fluency;
  if (startDate) params.start_date = startDate;
  if (endDate) params.end_date = endDate;
  const response = await api.post("/api/audio/export-filtered-annotations-csv", null, { params });
  return response.data;
};

// ── VAD Annotation ──────────────────────────────────────────────────────────

export const getVadNext = async () => {
  const response = await api.get("/vad/next");
  return response.data;
};

export const getVadAudioUrl = (fileId) => {
  const token = localStorage.getItem("companioToken");
  return `${API_BASE_URL}/vad/files/${fileId}/audio?token=${token}`;
};

export const submitVadAnnotations = async (fileId, annotations) => {
  const response = await api.post(`/vad/files/${fileId}/annotations`, { annotations });
  return response.data;
};

export const skipVadFile = async (fileId) => {
  const response = await api.post(`/vad/files/${fileId}/skip`);
  return response.data;
};

export const getVadStats = async () => {
  const response = await api.get("/vad/stats");
  return response.data;
};

export const getVadMyStats = async () => {
  const response = await api.get("/vad/my-stats");
  return response.data;
};

export const exportVadManifest = async (format = "jsonl") => {
  const response = await api.get("/vad/export", { params: { format } });
  return response.data;
};

export const configureVad = async (bucket, prefix, filename_filter) => {
  const response = await api.post("/vad/configure", { bucket, prefix, filename_filter });
  return response.data;
};

export const getVadConfig = async () => {
  const response = await api.get("/vad/config");
  return response.data;
};

// ── Conversation Annotation ─────────────────────────────────────────────────

export const getConversationNext = async () => {
  const response = await api.get("/conversation/next");
  return response.data;
};

export const getConversationAudioUrl = (fileId) => {
  const token = localStorage.getItem("companioToken");
  return `${API_BASE_URL}/conversation/files/${fileId}/audio?token=${token}`;
};

export const submitConversationAnnotations = async (fileId, annotations) => {
  const response = await api.post(`/conversation/files/${fileId}/annotations`, { annotations });
  return response.data;
};

export const skipConversationFile = async (fileId) => {
  const response = await api.post(`/conversation/files/${fileId}/skip`);
  return response.data;
};

// ── Conversation Review ─────────────────────────────────────────────────────

// The backend picks the conversation; 204 means nothing is left to review.
export const getNextReview = async () => {
  const response = await api.get("/conversation-review/next");
  return response.status === 204 ? null : response.data;
};

export const getReviewAudioUrl = (id) => {
  const token = localStorage.getItem("companioToken");
  return `${API_BASE_URL}/conversation-review/${id}/audio?token=${token}`;
};

export const addReviewComment = async (id, comment) => {
  const response = await api.post(`/conversation-review/${id}/comments`, comment);
  return response.data;
};

export const deleteReviewComment = async (id, commentId) => {
  const response = await api.delete(`/conversation-review/${id}/comments/${commentId}`);
  return response.data;
};

// ── Val4200 Vetting ─────────────────────────────────────────────────────────

// Claims (or resumes) this user's next pending clip; 204 means none are left.
export const getVettingNext = async () => {
  const response = await api.get("/val4200-vetting/next");
  return response.status === 204 ? null : response.data;
};

export const getVettingClip = async (row) => {
  const response = await api.get(`/val4200-vetting/${row}`);
  return response.data;
};

// Merges per key on the server, so send only the changed fields.
export const patchVettingClip = async (row, changes) => {
  const response = await api.patch(`/val4200-vetting/${row}`, changes);
  return response.data;
};

export const completeVettingClip = async (row) => {
  const response = await api.post(`/val4200-vetting/${row}/complete`);
  return response.data;
};

// Clips completed today (IST) per reviewer: {date, total, users: [{email, count}]}.
export const getVettingTodayStats = async () => {
  const response = await api.get("/val4200-vetting/stats/today");
  return response.data;
};

// ── Hit rates ───────────────────────────────────────────────────────────────

export const getHitRatesSummary = async (params) => {
  const response = await api.get("/hit-rates/summary", { params });
  return response.data;
};

// {items: [{phrase, clips, exact_hits, hit_rate_pct, top_misses: [{text, count}]}]}
export const getHitRatePhrases = async (params) => {
  const response = await api.get("/hit-rates/phrases", { params });
  return response.data;
};

// {total, items}; audio_url is presigned and can be null.
export const getHitRateClips = async (params) => {
  const response = await api.get("/hit-rates/clips", { params });
  return response.data;
};

// ── STT Validation Dashboard ────────────────────────────────────────────────

export const listEvalRuns = async (limit = 50) => {
  const response = await api.get("/api/eval/runs", { params: { limit } });
  return response.data;
};

export const getEvalPayload = async (runId = "latest") => {
  const response = await api.get("/api/eval/payload", { params: { run_id: runId } });
  return response.data;
};

export const getEvalWerCsvUrl = async (runId) => {
  const response = await api.get("/api/eval/wer-csv-url", { params: { run_id: runId } });
  return response.data;
};

export const getAgreementMetrics = async ({ startDate, endDate, validationRunId } = {}) => {
  const params = {};
  if (startDate) params.start_date = startDate;
  if (endDate) params.end_date = endDate;
  if (validationRunId) params.validation_run_id = validationRunId;
  const response = await api.get("/api/eval/agreement", { params });
  return response.data;
};

export const getValidationRuns = async () => {
  const response = await api.get("/api/eval/validation-runs");
  return response.data;
};

export const recomputeNormalizationWer = async ({ runId, filters, dictOverrides = {} }) => {
  const form = new FormData();
  form.append("run_id", runId);
  form.append("filters", JSON.stringify(filters));
  // Each override is a File object keyed by filter name.
  if (dictOverrides.safe_child)  form.append("safe_child_dict",  dictOverrides.safe_child);
  if (dictOverrides.hindi_child) form.append("hindi_child_dict", dictOverrides.hindi_child);
  if (dictOverrides.hindi_doro)  form.append("hindi_doro_dict",  dictOverrides.hindi_doro);
  const response = await api.post("/api/eval/recompute-wer", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
};

export { GOOGLE_CLIENT_ID, API_BASE_URL };
